<template>
    <tr class="center aligned">
        <td>
            <router-link
                :to="{name: 'edit_provider_operation', params: {identity: core_waybill.operation.identity}}"
                v-if="core_waybill.operation"
            >
                {{ core_waybill.operation.number }}
            </router-link>
        </td>
        <td> {{ core_waybill.material.name || '-' }} </td>
        <td> {{ core_waybill.number || '-' }} </td>
        <td> {{ core_waybill.consignee_phone || '-' }} </td>
        <td> {{ core_waybill.consignee_name || '-' }} </td>
        <td> {{ core_waybill.weight_in_kilo || '-' }} </td>
        <td> {{ core_waybill.collection || '-' }} </td>
        <td> {{ latest_status_name || '-' }}</td>
        <td class="center aligned">
            <router-link
                :to="{name: 'edit_core_waybill', params: {identity: core_waybill.identity}}"
                class="ui basic primary button"
            >
                {{ $t('ui.general.detail') }}
            </router-link>
        </td>
    </tr>
</template>

<script>
import moment from 'moment'
export default {
    props: {
        core_waybill: Object
    },
    data() {
        return {
            is_processing: false,
        }
    },
    computed: {
        latest_status_name() {
            try {
                return this.core_waybill.latest_status.name
            } catch (e) {
                return null
            }
        }
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
    }
}
</script>
